






import { Component, Emit, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';

@Component({
    name: 'SpecialSpan',
    components: {
    
    }
})
export default class  extends Vue {
    @Prop() public value!: string | number;

    @Watch('value')
    onChange() {
        // console.log("special span changed", this.value)
        this.$emit('afterChange')
    }

    
}


